import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import { BrowserRouter } from 'react-router-dom'; // Change from HashRouter to BrowserRouter

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter> {/* Changed from HashRouter to BrowserRouter */}
          <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

reportWebVitals();